export enum SmartMapActionName {
  DELAGETE_TO_ROUTE = 'DELAGETE_TO_ROUTE',
  SEND_TEXT_MESSAGE = 'SEND_TEXT_MESSAGE',
}

export enum GenericMapActionInput {
  SELECT = 'select',
  TEXT = 'text',
}

export interface IGenericMapActionType {
  name: SmartMapActionName;
  typeId: number;
}

export interface IGenericMapAction {
  id: number;
  typeId: number;
  inputLabel: string;
  actionName: string;
  inputType: GenericMapActionInput;
  options: any[];
  template: string;
  selectedOption?: any;
}

export interface IGenericMapExecutedAction {
  typeId: number;
  formContent: string;
  agreementIds: number[];
}
